import { useEffect, useState, ChangeEvent } from "react";
import Input from "@weave-design/input";
import { AuxiliaryPropertyEditorControl } from "./auxiliaryPropertyEditorControl";
import { PropertyEditor } from "./propertyEditor";
import "./inputs.css";

type Props = {
    value: number | null;
    title: string;
    disabled?: boolean;
    onSave: (value: number | null) => void;
    auxiliaryControl?: AuxiliaryPropertyEditorControl;
    onlyNatural?: boolean;
};

export const NumberPropertyEditor = ({
    value,
    title,
    disabled,
    auxiliaryControl,
    onSave,
    onlyNatural = false,
}: Props) => {
    const [inputValue, setInputValue] = useState<string>("");
    const placeholderValue = value === null ? "" : value.toString();

    useEffect(() => {
        setInputValue(value === null ? "" : value.toString());
    }, [value]);

    const onChange = (event: ChangeEvent<HTMLInputElement>) => {
        setInputValue(event.target.value);
    };

    const onBlur = () => {
        const trimmedInputValue = inputValue.trim();

        if (trimmedInputValue === "") {
            if (value !== null) {
                onSave(null);
            }
            setInputValue("");
            return;
        }

        let parsedValue: number;

        if (onlyNatural) {
            if (!/^\d+$/.test(trimmedInputValue)) {
                setInputValue(placeholderValue);
                return;
            }

            parsedValue = parseInt(trimmedInputValue, 10);
        } else {
            if (!/^\d+(\.\d+)?$/.test(trimmedInputValue)) {
                setInputValue(placeholderValue);
                return;
            }

            parsedValue = parseFloat(trimmedInputValue);
        }

        if (parsedValue !== value) {
            onSave(parsedValue);
        }

        setInputValue(parsedValue.toString());
    };

    return (
        <PropertyEditor title={title} auxiliaryControl={auxiliaryControl}>
            <Input
                placeholder={placeholderValue}
                value={inputValue}
                onChange={onChange}
                onBlur={onBlur}
                disabled={!!disabled}
            />
        </PropertyEditor>
    );
};
